import React from "react";
import "./Loader.css";

const CHARS = "01GLOBALSHARE$#&@!%^*+=~";
const COLUMNS = Array.from({ length: 30 }, (_, i) => i);

export default function Loader({ message }) {
  return (
    <div className="loader-overlay">
      <div className="loader-rain">
        {COLUMNS.map((i) => (
          <div
            key={i}
            className="loader-column"
            style={{
              left: `${(i / 30) * 100}%`,
              animationDelay: `${(i * 0.13) % 2.5}s`,
              animationDuration: `${2 + (i % 4) * 0.5}s`,
            }}
          >
            {Array.from({ length: 12 }, (_, j) => (
              <span key={j} className="loader-char">
                {CHARS[Math.floor(Math.random() * CHARS.length)]}
              </span>
            ))}
          </div>
        ))}
      </div>

      <div className="loader-center">
        <div className="loader-ring">
          <div className="loader-ring-inner" />
        </div>
        <div className="loader-logo">GLOBAL SHARE</div>
        {message && <div className="loader-msg">{message}</div>}
      </div>
    </div>
  );
}
